<template>
  <div class="view-news default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <div class="content-title-governet">Notícias</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 d-flex">
                  <img v-if="news.image_url" :src="news.image_url" alt class="image-news" />
                  <div class="title-news d-flex align-items-center">
                    <span>{{news.title}}</span>
                  </div>
                </div>
                <div class="col-12">
                  <div v-html="news.content" class="news-content"></div>
                  <div class="reference-info">
                    <span
                      v-id="news.reference_date"
                    >Notícia publicada em {{formatDate(news.reference_date)}}.</span>
                    <span v-id="news.reference">Fonte: {{news.reference}}</span>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 3vh">
                <div class="col-12">
                  <send-item-email
                    title="Envie essa notícia para um amigo"
                    :item_id="id"
                    url="send_news_email"
                  ></send-item-email>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/imports/Helpers";
import moment from "moment";
import SendItemEmail from "@/components/forms/SendItemEmail";

export default {
  name: "view-news",
  props: {
    id: Number
  },
  components: {
    SendItemEmail
  },
  data() {
    return {
      news: {}
    };
  },
  mounted() {
    if (!this.id) {
      this.id = this.$route.query.id;
    }
    this.getDataObject(this.id);
  },
  methods: {
    getDataObject: function(id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/news_public/${id}`)
        .then(response => {
          this.news = response.data;
          this.incrementAccess(this.news.id);
        });
    },
    incrementAccess: function(id) {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/news_access/${id}`)
        .then(response => {
        });
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.view-news {
  .title-news {
    // text-align: justify;
    font-size: 30px;
  }
  .image-news {
    height: 10vh;
    margin-right: 18px;
  }
  .news-content {
    padding-top: 2.5vh;
    padding-bottom: 2.5vh;
  }
  .reference-info {
    font-size: 12px;
    color: #5f6064;
  }
}
</style>